import { toDateFormat } from '../../../utilities/dateFormat';
export const checkScope = (value, min, max) => {
    var _a, _b;
    if (!(value === null || value === void 0 ? void 0 : value.start) || !(value === null || value === void 0 ? void 0 : value.end))
        return { startOutOfScope: false, endOutOfScope: false };
    const start = toDateFormat.startOfDay(value.start);
    const end = toDateFormat.endOfDay(value.end);
    const startOutOfScope = (start === null || start === void 0 ? void 0 : start.getTime()) < ((_a = toDateFormat.startOfDay(min)) === null || _a === void 0 ? void 0 : _a.getTime());
    const endOutOfScope = (end === null || end === void 0 ? void 0 : end.getTime()) > ((_b = toDateFormat.endOfDay(max)) === null || _b === void 0 ? void 0 : _b.getTime());
    return { startOutOfScope, endOutOfScope };
};
//# sourceMappingURL=checkScope.js.map